import { Time } from "@angular/common";
import { BaseDto } from "./base.dto";
import { MerchantDto } from "./merchant.dto";
import { ProductDto } from "./product.dto";

export class ProductHoursDto extends BaseDto {
    isAvailable: boolean;
    productId: number;
    merchantId: number;
    weekday: number;
    startTime: Time;
    endTime: Time;
    product?: ProductDto;
    merchant?: MerchantDto;
  }